function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameBoardTemplate = require('./game-board.template');
var GameBoard = /*#__PURE__*/function () {
  /**
   * @param app - the Saito application
   * @param mod - reference to the game module
   */
  function GameBoard(app, mod) {
    _classCallCheck(this, GameBoard);
    this.app = app;
    this.game_mod = mod;
    this.cards_visible = 0;
    this.timer = null;
  }
  return _createClass(GameBoard, [{
    key: "render",
    value: function render() {
      var enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (enable) {
        delete this.disable;
      }
      if (this.disable) {
        console.log("Prevent board rendering between rounds");
        return;
      }
      if (!this.game_mod.gameBrowserActive()) {
        return;
      }
      if (!document.querySelector(".gameboard")) {
        this.app.browser.addElementToDom(GameBoardTemplate(this.game_mod));
        this.attachEvents();
      }
      if (!this.game_mod.game.state.passed[this.game_mod.game.player - 1]) {
        this.game_mod.cardfan.render();
      }
      this.game_mod.pot.render();
      this.displayTable();
    }
  }, {
    key: "toggleView",
    value: function toggleView() {
      var gb = document.querySelector(".gameboard");
      if (!gb) {
        return;
      }
      if (this.game_mod.theme == "threed") {
        gb.classList.remove("flat");
        gb.classList.add("threed");
      } else {
        gb.classList.add("flat");
        gb.classList.remove("threed");
      }
    }
  }, {
    key: "changeFelt",
    value: function changeFelt() {
      var gb = document.querySelector(".gameboard");
      if (!gb) {
        return;
      }
      gb.classList.remove("green");
      gb.classList.remove("red");
      gb.classList.remove("blue");
      gb.classList.add(this.game_mod.felt);
    }
  }, {
    key: "displayTable",
    value: function displayTable() {
      var _this = this;
      var poker_self = this.game_mod;
      var animate_flip = this.game_mod.game.state.flipped > 0 && this.game_mod.game.state.flipped > this.cards_visible;
      console.log("POKER: display table -- ", this.game_mod.game.state.flipped, this.cards_visible);
      try {
        if (document.getElementById('deal')) {
          var newHTML = '';
          for (var i = 0; i < 5 || i < poker_self.game.pool[0].hand.length; i++) {
            var card = {};
            if (i < poker_self.game.pool[0].hand.length && i < this.cards_visible) {
              card = poker_self.game.pool[0].cards[poker_self.game.pool[0].hand[i]];
              newHTML += "<div class=\"card slot".concat(i + 1, "\"><img class=\"cardFront\" src=\"").concat(poker_self.card_img_dir, "/").concat(card.name, "\"></div>");
            } else {
              if (i < poker_self.game.pool[0].hand.length) {
                card = poker_self.game.pool[0].cards[poker_self.game.pool[0].hand[i]];
                newHTML += "<div class=\"flipped slot".concat(i + 1, " card\"><img class=\"cardFront\" src=\"").concat(poker_self.card_img_dir, "/").concat(card.name, "\"><img class=\"cardBack\" src=\"").concat(poker_self.card_img_dir, "/").concat(poker_self.card_img, ".png\"></div>");
              } else {
                newHTML += "<div class=\"flipped slot".concat(i + 1, " card\"><img class=\"cardBack\" src=\"").concat(poker_self.card_img_dir, "/").concat(poker_self.card_img, ".png\"></div>");
              }
            }
          }
          document.getElementById('deal').innerHTML = newHTML;
        }

        //
        // animate card flip
        //
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          console.log("Animate poker cards");
          if (animate_flip && _this.cards_visible < poker_self.game.pool[0].hand.length) {
            for (var _i = 0; _i < poker_self.game.pool[0].hand.length; _i++) {
              var obj = document.querySelector(".slot".concat(_i + 1));
              if (obj) {
                obj.classList.remove("flipped");
              }
            }
          } else {
            console.log("Skip animation: ", animate_flip, _this.game_mod.game.state.flipped, _this.cards_visible, poker_self.game.pool[0].hand.length);
          }
          _this.cards_visible = poker_self.game.pool[0].hand.length;
        }, 200);
      } catch (err) {
        console.warn('Card error displaying table:', err);
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }, {
    key: "clearTable",
    value: function clearTable() {
      this.cards_visible = 0;
      this.disable = true;

      //
      // this animation sweeps the cards off the table
      //
      $($('#deal').children().get().reverse()).each(function (index) {
        $(this).delay(50 * index).queue(function () {
          $(this).removeClass('flipped').delay(20 * index).queue(function () {
            $(this).animate({
              left: '1000px'
            }, 1200, 'swing', function () {
              $(this).remove();
            }).dequeue();
          }).dequeue();
        });
      });

      //
      // this animation sweeps the hands off the table
      //
      $('.game-playerbox-graphics .hand').animate({
        left: '1000px'
      }, 1200, 'swing', function () {
        $(this).remove();
      });
    }
  }]);
}();
module.exports = GameBoard;